/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'window'
],
function installationGuide(
    $,
    Mustache,
    pip,
    window
) {


    var view = {
        selectors: {
            installationGuideTitleWrapper: '#installation-guide-title-wrapper', 
            installationGuideDetailsWrapper: '#installation-guide-details-wrapper',
            installationGuideWrapper: '.installation-guide__wrapper',
            installationGuideDetailContainer: '.installation-guide__details-container'
        },
        classes: {
            installationGuideCollapseContainerCollapsed: 'installation-guide-collapsible-container--collapsed',
            installationGuideExpandedContainerExpanded: 'installation-guide-collapsible-container--expanded',
            installationGuideMobileCollapse: 'installation-guide__details-container--collapse'
        },
        templates: {
            installationGuideTitle: $('#installation-guide-title').html(), 
            installationInstructions: $('#installation-guide-instructions').html()  
        },
        render: {
            installationGuideTitle: function renderInstallationGuideTitle () {
                return Mustache.render(view.templates.installationGuideTitle, viewModel.doItYourself);
            },
            installationInstructions: function renderInstallationInstructions () {
                return Mustache.render(view.templates.installationInstructions, viewModel.doItYourself);
            }

        },
        elements: {
            installationGuide: window.document.getElementById('installation_guide'),
        },
        updateDOM: {
            installationGuideTitle: function updateInstallationGuideTitle() {
                $(view.selectors.installationGuideTitleWrapper).html(view.render.installationGuideTitle());
            },
            installationInstructions: function updateInstallationInstructions() {
                $(view.selectors.installationGuideDetailsWrapper).html(view.render.installationInstructions());
            }
        },
        initEventListeners: function initEventListeners() {
            $(window.document).off('.installationGuide', view.selectors.installationGuideWrapper)
            $(window.document).on('click.installationGuide', view.selectors.installationGuideWrapper, function () {
                $(this).toggleClass(view.classes.installationGuideExpandedContainerExpanded),
                $(view.selectors.installationGuideDetailContainer).toggleClass(view.classes.installationGuideMobileCollapse)
            });
        },
        showInstallationGuide: function showInstallationGuide () { 
            $(view.elements.installationGuide).removeClass('u--hide');
        },
        init: function init() {
            view.showInstallationGuide();
            view.updateDOM.installationGuideTitle(); 
            view.updateDOM.installationInstructions();  
            view.initEventListeners();   
        }
    };

    var viewModel = {
        doItYourself: {},
        diyLists: {
            maxItems: 7,
            checkLength: function checkLength(diyList) {
                if(!diyList) return;
                return diyList.length > viewModel.diyLists.maxItems;
            },
            limit : function limit(diyList) {
                if(!diyList) return;
                if(diyList.length > viewModel.diyLists.maxItems) {
                    return diyList.slice(0, this.maxItems-1)
                }
                return diyList;
            }
        },
        init: function init() { 
            $.extend(viewModel.doItYourself, pip.doItYourself);
                viewModel.doItYourself.shouldShowMoreProjectSteps = viewModel.diyLists.checkLength(viewModel.doItYourself.projectSteps);
                viewModel.doItYourself.shouldShowMoreToolsMaterialDetails = viewModel.diyLists.checkLength(viewModel.doItYourself.toolsAndMaterials);

            $.extend(viewModel.doItYourself, {
                projectSteps: viewModel.diyLists.limit(viewModel.doItYourself.projectSteps), 
                toolsAndMaterials: viewModel.diyLists.limit(viewModel.doItYourself.toolsAndMaterials)
            });
        }
    };
    
    function shouldDisplayInstallationGuide() {
        return   !!((pip.features.doItYourselfStandaloneEnabled) && (pip.doItYourself))
       }

    return {
        init: function() {
           if (shouldDisplayInstallationGuide()) 
            {
                viewModel.init();
                view.init();
            }
        },
        view: view,
        viewModel: viewModel,
        shouldDisplayInstallationGuide: shouldDisplayInstallationGuide
    }
})

}.call(window));